import { motion } from "framer-motion";
import { Calendar, Factory, Armchair, FolderCheck } from "lucide-react";

/**
 * StatsBar — Trust-stats strip for the homepage, placed above Industry Solutions.
 * Values are static (verified facts about Ezeefit): founding year, projects delivered,
 * in-house manufacturing share, IGBC certification and total workstations installed.
 */
const STATS = [
  { Icon: Calendar,    v: "2014",     l: "Manufacturing Since",   testid: "stat-year" },
  { Icon: FolderCheck, v: "500+",     l: "Projects Delivered",    testid: "stat-projects" },
  { Icon: Factory,     v: "100%",     l: "In-House Manufacturing",testid: "stat-inhouse" },
  { logo: "/certifications/igbc.png", v: "IGBC", l: "Certified Quality", testid: "stat-igbc" },
  { Icon: Armchair,    v: "50,000+",  l: "Workstations Installed",testid: "stat-workstations" },
];

export default function StatsBar() {
  return (
    <section
      className="py-14 lg:py-20 bg-[#FBF7F2] border-y border-[#E8DFD3]"
      data-testid="homepage-stats-bar"
      aria-label="Ezeefit at a glance — key manufacturing metrics"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-10 md:gap-y-0 md:gap-x-6">
          {STATS.map(({ Icon, logo, v, l, testid }, i) => (
            <motion.div
              key={testid}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex flex-col items-center text-center px-2"
              data-testid={testid}
            >
              <div className="w-14 h-14 rounded-full bg-white shadow-sm border border-[#E8DFD3] flex items-center justify-center mb-4 overflow-hidden">
                {logo ? (
                  <img
                    src={logo}
                    alt="IGBC Indian Green Building Council"
                    className="w-auto object-contain"
                    style={{ height: "44px" }}
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <Icon className="w-5 h-5 text-[#B91C1C]" strokeWidth={1.6} />
                )}
              </div>
              <div className="text-3xl lg:text-4xl font-serif text-[#1F2937] tracking-tight">{v}</div>
              <div className="mt-2 text-[11px] font-mono tracking-widest uppercase text-[#64748B]">{l}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
